import { render, staticRenderFns } from "./MyLesson.vue?vue&type=template&id=20985e52"
import script from "./MyLesson.vue?vue&type=script&lang=js"
export * from "./MyLesson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports